import { InjectionToken } from '@angular/core';

export const TIIME_OVERLAY_DATA = new InjectionToken<any>('TIIME_OVERLAY_DATA');
